import { render, staticRenderFns } from "./Targecustomer.vue?vue&type=template&id=71540cbf&scoped=true&"
import script from "./Targecustomer.vue?vue&type=script&lang=js&"
export * from "./Targecustomer.vue?vue&type=script&lang=js&"
import style0 from "./Targecustomer.vue?vue&type=style&index=0&id=71540cbf&scoped=true&lang=css&"
import style1 from "./Targecustomer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71540cbf",
  null
  
)

export default component.exports